import './Logo.scss';

export default function Logo() {
  return (
    <a href="/" className="logo" role="logo-link">
      mycent.kz
    </a>
  );
}
